import { render, staticRenderFns } from "./MiniProgram.vue?vue&type=template&id=395fc286"
import script from "./MiniProgram.vue?vue&type=script&lang=js"
export * from "./MiniProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports